import type { FrequentCustomerCard } from '@washday/utilities';

// Date inputs use calendar strings; keep API timestamps out of local-time conversion.
export function getFrequentCustomerCardFormValues(card?: FrequentCustomerCard | null) {
  const dateValue = (value?: Date | string | null) =>
    value instanceof Date ? value.toISOString().slice(0, 10) : value?.slice(0, 10) || '';

  return {
    number: card?.number || '',
    validFrom: dateValue(card?.validFrom),
    validThrough: dateValue(card?.validThrough)
  };
}

export function getFrequentCustomerCardPayload(
  card: ReturnType<typeof getFrequentCustomerCardFormValues>
): FrequentCustomerCard | null {
  if (!card.number.trim()) return null;
  return {
    number: card.number.trim(),
    validFrom: card.validFrom || null,
    validThrough: card.validThrough || null
  };
}
